export const PRODUCT_UNITS = {
  kg: [
    {
      name: "g",
      conversion: 1000,
    },
  ],
  l: [
    {
      name: "cl",
      conversion: 100,
    },
  ],
};

export const PRODUCT_KEY_ID_SEPARATOR = "___";
export const SECTION_UPDATE_INTERVAL = 60000;
export const BNGM_PRODUCT_SELECTOR_NAME = "Choisissez votre produit";

export const OFFER_SECTION_KEY = "OFFERS";
export const BNGM_PREFIX = "BNGM";
export const BNGM_SLOT_SEPARATOR = "_SLOT_";
export const OFFER_SECTION = {
  description: "Retrouvez toutes nos offres du moment",
  position: 0,
  key: OFFER_SECTION_KEY,
  minimumPrice: 0,
  name: "Nos Offres",
  iconUrl: "/assets/thresholdMarketing.png",
  hidden: false,
  products: {},
};
export const BNGM_SECTION_KEY = "BNGM_CAMPAIGN_PRODUCTS";

export const BNGM_SECTION_NAME = "Produits de campagne BNGM";

export const KEY_PREFIX = {
  SECTION: "SECTION_",
  PRODUCT: "PRODUCT_",
  OPTION: "OPTION_",
  ITEM: "ITEM_",
};

export const OFFER_PRODUCT_KEY_SEPARATOR = "__";
